module.exports = __webpack_public_path__ + "static/media/class-projects.9b061110.svg";